export type TOwnershipTypeId = number;

export interface OwnershipType {
  id: TOwnershipTypeId;
  name: string;
}
